<template>
  <p-app theme="glittr widget">
    <p-container>
      <slot></slot>
    </p-container>
  </p-app>
</template>

<script lang="ts">
  export default {
    data: () => ({
    }),
  };
</script>
